export class AgreementDistanceCalculationType {
	agreementDistanceCalculationTypeId: number;
	distanceCalculationTypeId: number;
	cityIds: number[] = [];
	distanceBufferZone?: number;
	isDefault: boolean;
}
